import React, { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("ft_user");
    return raw ? JSON.parse(raw) : null;
  });
  const [loading, setLoading] = useState(!!localStorage.getItem("ft_token"));

  useEffect(() => {
    const token = localStorage.getItem("ft_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me").then((r) => {
      setUser(r.data);
      localStorage.setItem("ft_user", JSON.stringify(r.data));
    }).catch(() => {
      localStorage.removeItem("ft_token");
      localStorage.removeItem("ft_user");
      setUser(null);
    }).finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("ft_token", r.data.token);
    localStorage.setItem("ft_user", JSON.stringify(r.data.user));
    setUser(r.data.user);
    return r.data.user;
  };
  const register = async (email, password, name) => {
    const r = await api.post("/auth/register", { email, password, name });
    localStorage.setItem("ft_token", r.data.token);
    localStorage.setItem("ft_user", JSON.stringify(r.data.user));
    setUser(r.data.user);
    return r.data.user;
  };
  const logout = () => {
    localStorage.removeItem("ft_token");
    localStorage.removeItem("ft_user");
    setUser(null);
    try { const { stopRealtime } = require("./realtime"); stopRealtime(); } catch {}
    window.location.href = "/login";
  };

  return <AuthCtx.Provider value={{ user, loading, login, register, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
